// eslint-disable-next-line import/no-cycle
import {
	deleteReq, getReq, postReq, putReq
} from '../../utils/request'
// eslint-disable-next-line import/no-cycle
import { ThunkResult } from '../index'

export interface IHousingAssociation {
	id: number
	name: string
	organizationID: number | null
	document1Label: string | null
	document1FileName: string | null
	document2Label: string | null
	document2FileName: string | null
	hasDocument1: boolean
	hasDocument2: boolean
	activeOrdersCount: number
}

export interface IHousingAssociationPriceOffer {
	id: number
	address: string | null
	status: string
	createdAt: string
	updatedAt: string
}

const HOUSING_ASSOCIATIONS_URL = '/api/admin/housing-associations'

export const getHousingAssociations = (
	onSuccess: (data: IHousingAssociation[]) => void = (() => {}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {})
): ThunkResult<Promise<IHousingAssociation[]>> => async () => {
	try {
		const { data } = await getReq(HOUSING_ASSOCIATIONS_URL)
		onSuccess(data)
		return data
	} catch (error) {
		onFailure(error)
		return error
	}
}

export const getHousingAssociationPriceOffers = (
	id: number,
	onSuccess: (data: IHousingAssociationPriceOffer[]) => void = (() => {}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {})
): ThunkResult<Promise<IHousingAssociationPriceOffer[]>> => async () => {
	try {
		const { data } = await getReq(`${HOUSING_ASSOCIATIONS_URL}/${id}/price-offers`)
		onSuccess(data)
		return data
	} catch (error) {
		onFailure(error)
		return error
	}
}

export const createHousingAssociation = (
	name: string,
	onSuccess: (data: IHousingAssociation) => void = (() => {}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {})
): ThunkResult<Promise<IHousingAssociation>> => async () => {
	try {
		const { data } = await postReq(HOUSING_ASSOCIATIONS_URL, null, { name })
		onSuccess(data)
		return data
	} catch (error) {
		onFailure(error)
		return error
	}
}

export const updateHousingAssociation = (
	id: number,
	name: string,
	onSuccess: (data: IHousingAssociation) => void = (() => {}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {})
): ThunkResult<Promise<IHousingAssociation>> => async () => {
	try {
		const { data } = await putReq(`${HOUSING_ASSOCIATIONS_URL}/${id}`, null, { name })
		onSuccess(data)
		return data
	} catch (error) {
		onFailure(error)
		return error
	}
}

export const deleteHousingAssociation = (
	id: number,
	onSuccess: () => void = (() => {}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {})
): ThunkResult<Promise<any>> => async () => {
	try {
		const { data } = await deleteReq(`${HOUSING_ASSOCIATIONS_URL}/${id}`)
		onSuccess()
		return data
	} catch (error) {
		onFailure(error)
		return error
	}
}
